export const NAVIGATION_STATUS = 'NAVIGATION_STATUS';

export const isOpen = nav => ({
	type: NAVIGATION_STATUS,
	payload: nav
});



// WEBPACK FOOTER //
// ./src/redux/actions/navigation.js